import * as isoly from "isoly";
import { getLanguage } from "./getLanguage";
export function create(translations, language) {
    let result;
    if (!language) {
        const translation = translations;
        result = (message, ...argument) => {
            const r = translation[message];
            return !r
                ? fallback(message, ...argument)
                : typeof r == "function"
                    ? r(...argument)
                    : argument.length > 0
                        ? fallback(r, ...argument)
                        : r;
        };
    }
    else {
        if (!isoly.Language.is(language))
            language = getLanguage(language);
        const translation = language && translations[language];
        result = translation ? create(translation) : fallback;
    }
    return result;
}
function fallback(message, ...argument) {
    return argument.length > 0 ? argument.reduce((r, a, i) => r.replace("$" + i, a), message) : message;
}
//# sourceMappingURL=create.js.map